import { Link, Span } from '@fareye/ui'
import { cancelToken, FaCheck, get, put } from '@fareye/utils'
import React from 'react'
import { useTranslation } from '@fareye/common'
import { ProfileSubMenu } from '../../style/styled'

export const IoLanguageOutline = (props: any) => {
  return (
    <svg
      stroke={'currentColor'}
      fill={'currentColor'}
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="1em"
      width="1em"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M48 112h288M192 64v48m80 336l96-224 96 224m-162.5-64h133M281.3 112S257 206 199 277 80 384 80 384"
      ></path>
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M256 336s-35-27-72-75-56-85-56-85"
      ></path>
    </svg>
  )
}

const source = cancelToken().source()

function Language({
  fetchPossibleLanguages = {
    url: '/api/v1/translations/supported_languages'
  },
  updateUserLanguagePreference = {
    url: '/api/v1/profile'
  }
}: {
  fetchPossibleLanguages?: { url: string }
  updateUserLanguagePreference?: { url: string }
}) {
  const [languageOptions, setLanguageOptions] = React.useState<{
    [key: string]: string
  }>({
    en: 'English',
    es: 'Espanol'
  })
  const { t, i18n } = useTranslation()
  let lng = i18n?.language || 'en'

  React.useEffect(() => {
    fetchSupportedLanguages()
  }, [])

  async function fetchSupportedLanguages() {
    try {
      const { data, status } = await get(
        `${fetchPossibleLanguages.url}`,
        source.token,
        {
          headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
        }
      )
      if (status === 200) {
        if (data.enabledLanguages) {
          setLanguageOptions(data.enabledLanguages)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  async function updateLanguagePreference(locale: string) {
    try {
      const { data, status } = await put(
        `${updateUserLanguagePreference.url}`,
        { locale },
        source.token,
        {
          headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
        }
      )
      if (status >= 200 && status < 300) {
        if (data.enabledLanguages) {
          setLanguageOptions(data.enabledLanguages)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  console.log(languageOptions, '**************')
  return (
    <Link to={'#'} onClick={(e: any) => e.preventDefault()}>
      <IoLanguageOutline height={19} width={19} />
      {t('language')}
      <ProfileSubMenu column>
        {Object.entries(languageOptions).map(
          ([locale, language]: [string, string], index: number) => {
            return (
              <Span
                key={locale}
                onClick={() => {
                  if (i18n) {
                    i18n.changeLanguage(locale)
                    updateLanguagePreference(locale)
                  }
                }}
              >
                {locale.toUpperCase()}
                {lng == locale ? (
                  <FaCheck
                    size={10}
                    style={{
                      marginLeft: 'auto',
                      padding: '3px 0 0 10px',
                      height: 10
                    }}
                  />
                ) : null}
              </Span>
            )
          }
        )}
      </ProfileSubMenu>
    </Link>
  )
}
export default Language
